import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quantity-panel-v2" }
const _hoisted_2 = { class: "quantity-panel-v2__value" }
const _hoisted_3 = ["disabled"]


import IconMinus from '@/icons/icon-minus.vue';
import IconPlus from '@/icons/icon-plus.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuantityPanelV2',
  props: {
  modelValue: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 99999,
  },
},
  emits: [
  'update:modelValue',
],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "quantity-panel-v2__btn quantity-panel-v2__btn--remove",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('update:modelValue', __props.modelValue - 1)), ["prevent"]))
    }, [
      _createVNode(IconMinus)
    ]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.modelValue), 1),
    _createElementVNode("button", {
      type: "button",
      class: "quantity-panel-v2__btn quantity-panel-v2__btn--add",
      disabled: __props.modelValue >= __props.max,
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('update:modelValue', __props.modelValue + 1)), ["prevent"]))
    }, [
      _createVNode(IconPlus)
    ], 8, _hoisted_3)
  ]))
}
}

})